"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ObjectForm = _interopRequireDefault(require("@/components/ObjectForm"));
var _project = require("@/api/project/project");
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    formIcon: _ObjectForm.default
  },
  data: function data() {
    return {
      formData: {
        rules: {
          stageName: [{
            required: true,
            message: "请输入阶段名称",
            trigger: "blur"
          }],
          beginTime: [{
            required: true,
            message: "请选择项目阶段开始时间",
            trigger: "blur"
          }],
          endTime: [{
            required: true,
            message: "请选择项目阶段结束时间",
            trigger: "blur"
          }],
          expertScoreEndTime: [{
            required: true,
            message: "请选择专家评分截止时间",
            trigger: "blur"
          }]
        },
        labelWidth: "150px",
        inline: false,
        labelPosition: "right",
        size: "small",
        formItem: [{
          type: "input",
          label: "阶段名称：",
          isDisabled: false,
          placeholder: "请输入阶段名称",
          prop: "stageName",
          value: ""
        }, {
          type: "dateTime",
          label: "开始时间：",
          prop: "beginTime",
          value: ""
        }, {
          type: "dateTime",
          label: "结束时间：",
          prop: "endTime",
          value: ""
        }, {
          type: "dateTime",
          label: "专家评分截止时间：",
          prop: "expertScoreEndTime",
          value: ""
        }]
      }
    };
  },
  methods: {
    submit: function submit(e) {
      var _this = this;
      e.id = "";
      e.matchId = this.$route.query.matchId;
      console.log(e);
      (0, _project.changeStage)(e).then(function (res) {
        if (res.code === 2000) {
          _this.$message.success("操作成功。");
          history.go(-1);
        } else {
          _this.$message.error("操作失败。");
        }
      });
    }
  }
};